import locales from 'locales/Locales';

let _language = 'en';
let _translations = locales.en;

if (typeof navigator !== 'undefined') {
    if (navigator.language.indexOf('fr') > -1) {
        _language = 'fr';
        _translations = locales.fr;
    }
}

const translate = (_locales, key) => _locales
    ? _locales[key]
    : '';

const i18n = {

    /**
     * Change the current language. Load the locales of the new language
     *
     * @param {string} language New language to load
     * @returns
     */
    setLanguage(language) {
        if (!language || !(typeof language === 'string') || !locales[language]) {
            return false;
        }

        _language = language;

        _translations = locales[language];
        return true;
    },

    getCurrentLanguage() {
        return _language;
    },

    getCurrentTranslations() {
        return _translations;
    },

    i18n(key, translateObj) {
        if (arguments.length < 1) {
            console.log('missing arguments');
            return '';
        }

        try {
            let sentence = translate(_translations, key);
            if (translateObj) {
                for (const k in translateObj) {
                    sentence = sentence.split('{' + k + '}').join(translateObj[k]);
                }
            }
            return sentence;
        } catch (e) {
            console.log('Cannot get translation for "' + key + '" in ' + _language);
        }
    }
};

export default i18n;
